import React from "react";
import {Route, Routes} from "react-router-dom";
import APIKeyList from "../features/management-v2/api-keys/APIKeyList";
import APIKeyCreate from "../features/management-v2/api-keys/APIKeyCreate";

export function APIKeyRoutes() {
    return (
        <Routes>
            <Route path="" element={<APIKeyList />} />
            <Route path="create" element={<APIKeyCreate />} />
        </Routes>
    );
}